import classNames from 'classnames';

import { createPolygonTypes } from '../constants';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import './PolygonCreationSection.css';

const PolygonCreationSection = (props) => {
	const {
		selectedDrawingShape,
		changeDrawingShape,
	} = props;

	return (
		<div className='PolygonCreationSection'>
			<div
				className='PolygonCreationSection_Title'
				onClick={props.stopPolygonEditingShape}
			>
				Draw
			</div>

			<ul className='PolygonCreationSection_Items'>
				{createPolygonTypes.map((item, index) => (
					<li
						className={classNames({
							PolygonCreationSection_Btn: true,
							PolygonCreationSection_Item: true
						})}
						key={index}
						onClick={() => changeDrawingShape(item.name, item.geometry)}
					>
						{selectedDrawingShape !== item.name &&
							<SvgAF
								className='PolygonCreationSection_Item_Image'
								img={item.icon}
								hover={item.iconHover}
								alt='Creation image'
							/>
						}

						{selectedDrawingShape === item.name &&
							<SvgAF
								className='PolygonCreationSection_Item_Image_Selected'
								img={item.iconHover}
								alt='Creation image'
							/>
						}
					</li>
				))}
			</ul>
		</div>
	)
};

export default PolygonCreationSection;